export const PROD_MATCHMAKING_FORM_UUID =
  "3e07784a-f3fb-412e-aefb-d9be4a4677ec";

export const PROD_BUG_REPORT_FORM_UUID = "c83717bd-77ae-41dd-a811-bbccb4841dbf";
export const PROD_IDEA_FORM_UUID = "7a73c5fe-c347-4ea9-ad6b-76e4e9389d8b";
export const PROD_ONBOARDING_AVAILABILITY_FORM_UUID =
  "b355b09f-d5ba-433d-b86f-54ed85b527cb";
export const PROD_ONBOARDING_AVAILABILITY_FORM_REF = "AAAAAAAAlzY=";
export const PROD_ONBOARDING_AVAILABILITY_FORM_TITLE =
  "Let’s schedule your onboarding call";
